module.exports = __webpack_public_path__ + "img/rightbicep-ectomorph-male.e740562d.svg";